mutation CreatePledge(
  $userId: ID!
  $firstName: String!
  $surname: String!
  $pledge: PledgeInput!
) {
  createPledge(
    input: {
      userId: $userId
      firstName: $firstName
      surname: $surname
      pledge: $pledge
    }
  ) {
    pledge {
      id
    }
  }
}
